module.exports = __webpack_public_path__ + "static/media/img24.404af7c6.jpg";